var EventEmitter = require("events");
module.exports = new EventEmitter();



//////////////////
// WEBPACK FOOTER
// (webpack)/hot/emitter.js
// module id = ../../../../webpack/hot/emitter.js
// module chunks = vendor